import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';
import Header from './components/Header';
import Copyright from './components/Copyright';
import SignInAdminMain from './components/Main/SignIn';
import RecoverPasswordAdmin from './components/Main/RecoverPasswordAdmin';
import FormRecoverPassword from './components/Main/FormRecoverPassword';
import { RECOVER_PASSWORD_ADMIN, NEW_PASSWORD_ADMIN, SIGNIN_ADMIN } from '../../routes';
import { withRouter } from 'react-router';
import './Admin.scss';

const SignInAdmin = ({ history }) => {
  return (  
    <div className="signAdmin-container">
        <BrowserView>
            <div>
              <Header />
                <div className="container-general container-background">      
                 <Switch>
                   <Route exact path={SIGNIN_ADMIN} component={SignInAdminMain} />
                   <Route path={RECOVER_PASSWORD_ADMIN} component={RecoverPasswordAdmin} />
                 </Switch>
               </div> 
              <Copyright />
            </div>
        </BrowserView>
        <MobileView>
            <div className="sign-in_center">
            <BrowserRouter>
              <Switch>
                <Route exact path={SIGNIN_ADMIN} component={SignInAdminMain} />
                <Route path={RECOVER_PASSWORD_ADMIN} component={RecoverPasswordAdmin} />
              </Switch>
            </BrowserRouter>
            </div>
        </MobileView>
    </div>
  );
}

export default withRouter(SignInAdmin);
